module.exports = __webpack_public_path__ + "img/welding-12.4d22c0d2.jpg";